import React from "react";
import "../styles/global.css";
import "../styles/ConfirmationScreen.css";
import {  formatCustomerName, formatDateLong_cancel, formatLocation, getTimeDifferenceInMinutes, formatTestType } from "../utils/lib";

const CancelScreen = ({ bookingData }) => {
  if (!bookingData) return null; // Render nothing if no data

  const location = formatLocation(bookingData?.location) || "";
  const testType = formatTestType(bookingData?.testId) || "";
  const appointmentDate = bookingData?.time?.appointmentDate;
  const startTime = bookingData?.time?.startTimeReadable;
  const endTime = bookingData?.time?.endTimeReadable;
  const staffName = bookingData?.staffName || "";

  const duration = getTimeDifferenceInMinutes(startTime, endTime) || 0;

  return (
    <div className="main">
      <div className="page-text">
        <h1 className="page-heading">Appointment Cancelled</h1>
        <p className="page-description">
          Your appointment has been cancelled.
        </p>
        <p className="detail-pargraph" style={{ marginTop: '30px' }}>
          {testType} at {location} on {formatDateLong_cancel(appointmentDate)} at {startTime} for {duration} minutes with {staffName}
        </p>
      </div>
    </div>
  );
};

export default CancelScreen;
